import FormService from '../services/form.service'
import {
  _COMMIT_LOG, FORM_GET_FORMS,
} from './actions.types'
import {
  FORM_SET_FORMS,
} from './mutations.types'

const initialState = {
  forms: [],
}
export const state = { ...initialState }

export const actions = {
  async [FORM_GET_FORMS] ({ dispatch, commit, rootState, state }, payload) {
    try {
      dispatch(_COMMIT_LOG, { message: 'Retrieving system forms', payload })
      const { data } = await FormService.get()
      commit(FORM_SET_FORMS, data)
      return data
    } catch (e) {
      const processedError = await dispatch('processAxiosError', e)
      dispatch(_COMMIT_LOG, { message: 'Exception retrieving system forms', error: processedError })
      return []
    }
  },
}

export const mutations = {
  [FORM_SET_FORMS] (state, payload) {
    state.forms = payload
  },
}
export const getters = {
  forms: state => state.forms,
}
export default {
  state,
  actions,
  mutations,
  getters,
}
